// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 4465 ? "DashboardMobileNavbar" : chunkId) + "." + {"32":"674c1cf3","4465":"8432fc1e"}[chunkId] + ".chunk.css";
};